import React, { Component } from 'react';
import { Route } from "react-router-dom";
import UnauthorizedAccess from '../UnauthorizedAccess/UnauthorizedAccess';
import axios from 'axios';
import config from "../../config";
import Header from '../Header/Header';
import VideoPlayer from "../VideoPlayer/VideoPlayer"
import './BookSolutions.css';
import Cookies from 'js-cookie'
import { setContext } from '../../utils/analytics';

class BookSolutions extends Component {
  constructor(props) {
    super(props)

    this.authorizationRequestId = 0;
    this.tocRequestId = 0;

    this.state = {
      videoJsOptions: {},
      hasPurchasedBookAccess: false
    };
  }

  verifyAccess() {
    const { book_id } = this.props.match.params;
    const currentUser = this.props.currentUser;
    const requestId = ++this.authorizationRequestId;
    const isCurrent = () => requestId === this.authorizationRequestId &&
      currentUser === this.props.currentUser && book_id === this.props.match.params.book_id;

    setContext(null);
    this.setState({ hasPurchasedBookAccess: false });

    if (!this.props.authenticationSettled) { return; }

    if (currentUser) {
      return axios.get(config.api.DOMAIN + '/api/auth/authorize', {
        withCredentials: true,
        params: {
          'book_id': book_id
        }
      })
      .then(responseData => {
        if (!isCurrent()) { return; }
        setContext(responseData.data);
        this.setState({
          hasPurchasedBookAccess: responseData.data.has_access
        });
        this.props.onAnalyticsContextReady?.();
      })
      .catch(error => {
        if (!isCurrent()) { return; }
        setContext(null);
        console.error(error);
        this.props.onAnalyticsContextReady?.();
      });
    }
  }

  componentDidMount() {
    this.readerActive = true;
    const book_id = this.props.match.params.book_id;
    const filename = this.props.match.params.filename;

    this.verifyAccess();
    this.setState({
      book_id: book_id,
      filename: filename
    });
    this.loadToc();
    this.setVideo();
  }

  loadToc() {
    const { book_id } = this.props.match.params;
    const requestId = ++this.tocRequestId;
    const isCurrent = () => this.readerActive && requestId === this.tocRequestId &&
      book_id === this.props.match.params.book_id;

    // get the toc for the book
    return fetch(`/tocs/${book_id}.json`)
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }

      return response.json();
    })
    .then(data => {
      if (!isCurrent()) { return; }
      this.setState({
        authors: data.authors,
        title: data.title,
      }, () => {
        if (!isCurrent()) { return; }
        document.title = `${data.title} | FlatWorld Viewer`;
      });
    })
    .catch(error => {
      if (!isCurrent()) { return; }
      console.log('Looks like there was a problem: \n', error);
    });
  }

  setVideo() {
    const solutions_book_id = 32281;
    const filepath = `/${solutions_book_id}/video_files/solutions/${this.props.match.params.filename}`

    axios.get(config.api.DOMAIN + '/api/content/videos', {
      withCredentials: true,
      params:
      {
        'videoPath': filepath
      }
    })
    .then(result => {

      Cookies.set('CloudFront-Policy', result.data.video_urls['cookies']['CloudFront-Policy'], { secure: true});
      Cookies.set('CloudFront-Signature', result.data.video_urls['cookies']['CloudFront-Signature'], { secure: true});
      Cookies.set('CloudFront-Key-Pair-Id', result.data.video_urls['cookies']['CloudFront-Key-Pair-Id'], { secure: true});
      this.setState({
        videoJsOptions: {
        autoPlay: true,
        controls: true,
        sources: [
          {
            src: result.data.video_urls['hls'],
            type: 'application/x-mpegURL',
            withCredentials: true,
          },
          {
            src: result.data.video_urls['dash'],
            type: 'application/dash+xml',
            withCredentials: true,
          },
          {
            src: result.data.video_urls['mp4'],
            type: 'video/mp4',
            withCredentials: true
          }
        ],
        poster: result.data.video_urls['thumbnail'],
        withCredentials: true
      }
      });
    })
    .catch(error => {
      console.error(error);
    });
  }

  componentDidUpdate(prevProps) {
    const bookChanged = prevProps.match.params.book_id !== this.props.match.params.book_id;
    const userChanged = prevProps.currentUser !== this.props.currentUser;
    if (bookChanged) {
      this.loadToc();
    }
    if (userChanged || bookChanged ||
        prevProps.authenticationSettled !== this.props.authenticationSettled) {
      this.verifyAccess();
    }
  }

  componentWillUnmount() {
    this.readerActive = false;
    this.authorizationRequestId += 1;
    this.tocRequestId += 1;
    setContext(null);
  }

  isAuthorized(){
    return (this.getRolePrivileges() || this.state.hasPurchasedBookAccess)
  }

  contentLoaded(){
    return this.state.videoJsOptions && this.state.videoJsOptions['sources'] !== undefined;
  }

  getRolePrivileges(){
    let userIsAdminOrEducator = false;
    const { currentUser } = this.props;

    if (currentUser) {
      const userRoles = currentUser.roles;
      if (userRoles && (userRoles.includes("internal") || userRoles.includes("educator"))) {
        userIsAdminOrEducator = true;
      }
    }

    return userIsAdminOrEducator;
  }

  render() {
    const isAuthorized = this.isAuthorized();
    const contentLoaded = this.contentLoaded();
    const { currentUser } = this.props;
    const { title } = this.state;

    return (
      <div className="BookSolutions">

        <a href="#content" className="skip-main" tabIndex="-1">Skip to main content</a>

        <Header 
          currentUser={currentUser} 
          title={title}
          toggleDrawer={null} />

        {isAuthorized ? (

          <div id="content" className="Solution-content">
            {contentLoaded ? (
              <Route path={`${this.props.match.path}/watch`}
                render={() => <VideoPlayer videoJsOptions={this.state.videoJsOptions} />} />

            ) : (
              <div></div>
            )}
          </div>
        ) : (
          <UnauthorizedAccess/>
        )}
      </div>
    );
  }
}

export default BookSolutions;
